const stripe = {
  title: 'Stripe',

  billing_unavailable:
    'La facturación aún no está disponible para este distribuidor. Por favor, contacte con soporte.',

  sync: {
    explanation:
      'Este botón permite iniciar una sincronización para actualizar el número de puertas facturables en Stripe.',
    button: 'Iniciar una sincronización',
  },
};

export default stripe;
